import { inject } from "vue";
import { propertyFieldKey, type PropertyFieldContext } from "@/keys";

export function usePropertyField<T = unknown>(): PropertyFieldContext<T> {
	const context = inject<PropertyFieldContext<T>>(propertyFieldKey);
	if (!context) {
		throw new Error(
			"usePropertyField must be used within a PropertyField component",
		);
	}
	return context;
}

export function usePropertyFieldOptional<T = unknown>():
	| PropertyFieldContext<T>
	| undefined {
	return inject<PropertyFieldContext<T> | undefined>(
		propertyFieldKey,
		undefined,
	);
}
